var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"80px"}},[_c('vue-apex-charts',{attrs:{"type":"radialBar","height":"160","options":_vm.apexChatData.radialBarChart.chartOptions,"series":_vm.apexChatData.radialBarChart.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }